<script lang="ts">
</script>

<svg
  width="96"
  height="96"
  viewBox="0 0 96 96"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle
    cx="48"
    cy="48"
    r="48"
    fill="url(#paint0_linear_3096_54138)"
    fill-opacity="0.3"
  />
  <circle opacity="0.1" cx="48.0011" cy="47.9984" r="29.0909" fill="#1EA961" />
  <mask
    id="mask0_3096_54138"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="37"
    y="34"
    width="28"
    height="27"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3578 34.4114L37.9618 56.7741L42.05 60.8654L64.446 38.5028L60.3578 34.4114Z"
      fill="url(#paint1_linear_3096_54138)"
    />
  </mask>
  <g mask="url(#mask0_3096_54138)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.4087 34.4604L38.0127 56.823L42.0516 60.8654L64.4476 38.5028L60.4087 34.4604Z"
      fill="#1EA961"
    />
  </g>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M33.879 46.0881L45.5145 57.3719L42.0823 60.8653L30.4468 49.5815L33.879 46.0881Z"
    fill="#1EA961"
  />
  <defs>
    <linearGradient
      id="paint0_linear_3096_54138"
      x1="48"
      y1="0"
      x2="48"
      y2="96"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1EA961" stop-opacity="0.38" />
      <stop offset="1" stop-color="#1EA961" stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_3096_54138"
      x1="64.1899"
      y1="36.3023"
      x2="45.8732"
      y2="64.6619"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#6FBAFE" />
      <stop offset="1" stop-color="#0C7EE4" />
    </linearGradient>
  </defs>
</svg>
